<template>
  <div class="home">
    <CustomerPiutangList />
  </div>
</template>

<script>
// @ is an alias to /src
import CustomerPiutangList from '@/components/customer/CustomerPiutangList.vue'

export default {
  name: 'CustomerPiutang',
  components: {
    CustomerPiutangList
  },
  mounted () {
    this.$store.dispatch('getRowTable')
  }
}
</script>
